import Modal from '@Atom/Modal'
import Styles from './style.module.scss'
import Card from '@Atom/Card'
import ModalHeader from '@Atom/ModalHeader'

export default function ViewPaymentProofModal({
  proof,
  show = false,
  setShow
}) {

  return (
    <Modal isOpen={show}>
      <Card className={Styles.container}>
        <ModalHeader
          title='Bukti Pembayaran'
          withCloseOption
          onClose={() => setShow(false)}
          className={Styles.header}
        />
        <img alt='' src={proof} />
      </Card>
    </Modal>
  )
}